import { Button, Flex, Input, Stack, Text } from '@chakra-ui/react'
import { ReactElement } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  LuArmchair,
  LuBriefcase,
  LuBuilding2,
  LuGraduationCap,
  LuHandshake,
  LuHeart,
  LuHouse,
  LuLandmark,
  LuShapes,
  LuTrophy,
  LuUsers,
  LuUsersRound,
} from 'react-icons/lu'

import { CircleWizardFormData, CommunityTypeValue } from '../types'

const TYPE_OPTIONS: {
  value: CommunityTypeValue
  i18nKey: string
  icon: ReactElement
}[] = [
  { value: 'neighborhood', i18nKey: 'neighborhood', icon: <LuHouse /> },
  { value: 'building', i18nKey: 'building', icon: <LuBuilding2 /> },
  { value: 'association', i18nKey: 'association', icon: <LuUsers /> },
  { value: 'company', i18nKey: 'company', icon: <LuBriefcase /> },
  { value: 'local_authority', i18nKey: 'localAuthority', icon: <LuLandmark /> },
  { value: 'third_place', i18nKey: 'thirdPlace', icon: <LuArmchair /> },
  { value: 'school', i18nKey: 'school', icon: <LuGraduationCap /> },
  { value: 'cooperative', i18nKey: 'cooperative', icon: <LuHandshake /> },
  { value: 'club', i18nKey: 'club', icon: <LuTrophy /> },
  { value: 'family', i18nKey: 'family', icon: <LuHeart /> },
  { value: 'friends', i18nKey: 'friends', icon: <LuUsersRound /> },
  { value: 'other', i18nKey: 'other', icon: <LuShapes /> },
]

export const CommunityTypeField = () => {
  const { t } = useTranslation()
  const { control, register } = useFormContext<CircleWizardFormData>()
  const selectedType = useWatch({ control, name: 'type' })

  return (
    <Stack gap={3} width="full">
      <Text fontWeight="medium" textStyle="sm">
        {t('communities.new.type.label')}
      </Text>
      <Controller
        name="type"
        control={control}
        render={({ field }) => (
          <Flex wrap="wrap" gap={2}>
            {TYPE_OPTIONS.map((option) => {
              const isSelected = field.value === option.value
              return (
                <Button
                  key={option.value}
                  type="button"
                  size="lg"
                  rounded="full"
                  colorPalette="blue"
                  variant={isSelected ? 'solid' : 'outline'}
                  onClick={() => field.onChange(option.value)}
                >
                  {option.icon}
                  {t(`communities.new.type.${option.i18nKey}`)}
                </Button>
              )
            })}
          </Flex>
        )}
      />
      {selectedType === 'other' && (
        <Input
          {...register('customTypeLabel')}
          placeholder={t('communities.new.type.customPlaceholder')}
          autoFocus
        />
      )}
    </Stack>
  )
}
